import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const GetOfferName = createAsyncThunk(
  "offerName/GetOfferName",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(endPoint.GETOFFERNAME);
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const GetOfferNameSlice = createSlice({
  name: "OfferName",
  initialState: {
    OfferName: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetOfferName.fulfilled, (state, action) => {
        state.OfferName = action.payload;
      })
      .addCase(GetOfferName.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default GetOfferNameSlice.reducer;
